<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_vi"></a> </p>
<p class="copyright"> </p>
<p class="copyright"><span class="small">THE HEART OF REDNESS</span>. Copyright © 2000 by Zakes Mda. All rights reserved. Printed in the United States of America. For information, address Picador, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyright1"><span class="weblink"><a class="nounder" href="http://www.picadorusa.com" target="_blank">www.picadorusa.com</a></span></p>
<p class="copyright1">Picador<sup>®</sup> is a U.S. registered trademark and is used by Farrar, Straus and Giroux under license from Pan Books Limited.</p>
<p class="copyright1">For information on Picador Reading Group Guides, as well as ordering, please<br/>contact the Trade Marketing department at St. Martin’s Press.<br/>Phone: 1-800-221-7945 extension 763<br/>Fax: 212-677-7456<br/>E-mail: trademarketing@stmartins.com</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Mda, Zakes.</p>
<p class="copyright2">The heart of redness / Zakes Mda.</p>
<p class="copyright2">         p. cm.</p>
<p class="copyright2">ISBN 0-312-42174-5       ISBN 978-0-312-42174-8</p>
<p class="copyright2">1. Triangles (Interpersonal relations)—Fiction. 2. Xhosa (African people)—Fiction. 3. South Africa—Fiction. 4. Villages—Fiction. 5. Casinos—Fiction. I. Title.</p>
<p class="copyright3">PR9369.3.M4 H43 2002<br/>823'.914—dc21                                                           2002025008</p>
<p class="copyright1">First published in the United States by Farrar, Straus and Giroux</p>
<p class="copyright1">First published in South Africa by Oxford University Press</p>
<p class="copyright1"><br/><br/>10   9   8   7   6</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5e1d3160